import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const Tick: React.FC<IconProps> = ({
  className = '',
  fill = colors.green,
  width = 25,
  height = 25,
  cssHelper = Styling.transitionVisible,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={`0 0 ${width} ${height}`}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G>
        <Elements.Circle cx='12.5' cy='12.5' r='12.5' fill={fill} />
        <Elements.G transform='matrix(1,0,0,1,6,7)'>
          <Elements.Path
            d='M5.913,9.31L4.338,11L0,6.345L1.575,4.655L4.338,7.62L11.441,0L13,1.69L5.913,9.31Z'
            fill={colors.white}
            fillRule='nonzero'
          />
        </Elements.G>
      </Elements.G>
    </Elements.Svg>
  );
};

export default Tick;
